export const ENV_VARIABLES = {
  apiBaseUrl:
    process.env.NODE_ENV === 'production' ? window.config.API_BASE_URL : process.env.REACT_APP_DEV_API_BASE_URL,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  googleMapsId: process.env.REACT_APP_GOOGLE_MAPS_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Check for configuration validity
export const checkAppConfig = () => {
  const errors: string[] = [];

  if (!ENV_VARIABLES.apiBaseUrl || ENV_VARIABLES.apiBaseUrl.includes('API_BASE_URL_PLACEHOLDER')) {
    errors.push('API_BASE_URL is not properly configured');
  }

  if (errors.length > 0) {
    console.error('Configuration errors:', errors);
    return false;
  }

  return true;
};
